/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_footer_rights = /** @type {(inputs: { start: NonNullable<unknown>, year: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.start} - ${i?.year} Juslin KOMENAN. Tous droits réservés.`)
};

const en_footer_rights = /** @type {(inputs: { start: NonNullable<unknown>, year: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.start} - ${i?.year} Juslin KOMENAN. All rights reserved.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ start: NonNullable<unknown>, year: NonNullable<unknown> }} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const footer_rights = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.footer_rights(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("footer_rights", locale)
	if (locale === "fr") return fr_footer_rights(inputs)
	return en_footer_rights(inputs)
};